import { extend, localize } from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru.json';
import * as rules from 'vee-validate/dist/rules';

extend('phone', (value) => {
  const pattern = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
  if (pattern.test(value)) {
    return true;
  }

  return 'Неправильно набран номер';
});


Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize('ru', ru);
